import type {
  ChronologicalItinerary,
  IngredientId,
} from '@libs/trip-planner-interfaces';

import type { LocationSegment } from '../../models';
import { ItinerarySegmentType } from '../../models';
import type { ItineraryDateLocationSegment } from '../../models/itinerarySegments/dateLocation';

interface DateLocationSegmentData {
  ingredientId: IngredientId;
  numberOfNights: number;
  displayText: string;
  mainPolygonFullName?: string;
}

const DESTINATION_TEXT_SEPARATOR = ',';

export function getTripOverviewDateLocationSegment(
  itineraryByPeriod: ChronologicalItinerary,
  {
    ingredientId,
    numberOfNights,
    displayText,
    mainPolygonFullName,
  }: DateLocationSegmentData
): ItineraryDateLocationSegment {
  const location = getLocationSegment(displayText, mainPolygonFullName);

  return {
    segmentType: ItinerarySegmentType.DateLocation,
    time: {
      relativeDays: itineraryByPeriod.dayPeriod || '',
      absoluteDays: itineraryByPeriod.datePeriod || '',
      absoluteShortDays: itineraryByPeriod.shortDatePeriod || '',
    },
    location,
    ingredientId,
    numberOfNights,
  };
}

export function getLocationSegment(
  displayText: string,
  mainPolygonFullName?: string
): LocationSegment {
  const city = getCityText(displayText, mainPolygonFullName);

  const country = getCountryText(displayText, mainPolygonFullName);

  return {
    name: city,
    country: country !== city ? country : undefined,
  };
}

export function getCityText(
  displayText: string,
  mainPolygonFullName?: string
): string {
  const destinationText = displayText ?? mainPolygonFullName;

  return destinationText.indexOf(DESTINATION_TEXT_SEPARATOR) > -1
    ? destinationText
        .slice(0, destinationText.lastIndexOf(DESTINATION_TEXT_SEPARATOR))
        .trim()
    : destinationText.trim();
}

export function getCountryText(
  displayText: string,
  mainPolygonFullName?: string
): string | undefined {
  const destinationText = mainPolygonFullName ?? displayText;

  return destinationText.indexOf(DESTINATION_TEXT_SEPARATOR) > -1
    ? destinationText
        .slice(
          destinationText.lastIndexOf(DESTINATION_TEXT_SEPARATOR) +
            DESTINATION_TEXT_SEPARATOR.length
        )
        .trim()
    : undefined;
}
